import styled from 'styled-components';
import Form from 'react-bootstrap/Form';

export const ContainerPasswordStyled = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    max-width: 928px;
    width: 100%;
    height: 45px;
    margin-bottom: 15px;
`;

export const ContainerEyeStyled = styled.div`
    cursor: pointer;
    position: absolute;
    right: 2%;
`;

export const FormRow = styled(Form.Row)`
  margin: 0;
`;

export const FormControl = styled(Form.Control)`
  max-width: 492px;
  margin-bottom: 0px !important;
`;